<template>
  <div class="alerts">
    <div class="alerts-item"
         v-for="(al, alIndex) in dataAlerts"
         :key="alIndex"
         v-bind:class="{ 'alerts-item__error'   : al.type === 'error',
                      'alerts-item__success' : al.type === 'success' }">
      <span class="alerts-text">{{al.text}}</span>
      <span class="alerts-close" v-on:click="closeAlert( alIndex )"></span>
    </div>
  </div>
</template>

<script>
  export default {
    methods : {
      closeAlert : function ( index ) {
        this.$store.dispatch('delAlert', index);
      }
    },
    computed : {
      dataAlerts(){
        return this.$store.state.alerts
      }
    }
  }
</script>